import { useState, useMemo } from 'react';

export interface ColumnConfig {
  title: string;
  key: string;
  visible?: boolean;
  [key: string]: any;
}

export const useColumnVisibility = <T extends ColumnConfig>(
  baseColumns: T[],
  defaultVisible?: boolean
) => {
  const [columnConfig, setColumnConfig] = useState<T[]>(() =>
    baseColumns.map((col) => ({ ...col, visible: col.visible ?? (defaultVisible ?? true) }))
  );

  const visibleColumns = useMemo(
    () => columnConfig.filter((col) => col.visible),
    [columnConfig]
  );

  const handleColumnVisibilityChange = (keys: React.Key[]) => {
    setColumnConfig((prev) =>
      prev.map((col) => ({
        ...col,
        visible: keys.includes(col.key),
      }))
    );
  };

  const visibleKeys = useMemo(
    () => visibleColumns.map((col) => col.key),
    [visibleColumns]
  );

  return {
    columnConfig,
    visibleColumns,
    visibleKeys,
    handleColumnVisibilityChange,
    setColumnConfig,
  };
};

